export var SizeClsMap = {
    small: ['w-px-32', 'h-px-32', 'text-sm', 'flex', 'justify-center', 'items-center'],
    normal: ['w-px-40', 'h-px-40', 'text-base', 'flex', 'justify-center', 'items-center'],
    large: ['w-px-48', 'h-px-48', 'text-lg', 'flex', 'justify-center', 'items-center'],
};
